import React, {Component} from 'react'
import Notification from '../components/Notification';
import NavBar from '../components/NavBar'
import FileUploader from 'react-firebase-file-uploader'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import firebase from '../config/database'
require("firebase/firestore");

var Loader = require('halogen/PulseLoader');


class Storage extends Component {

    constructor(props) {
        super(props);
        this.unsubscribe = null;
        this.state={
            isLoading:true,
            isUploading: false,
            progress: 0,
            images: [],
            copied: false
        }
    }

    componentDidMount() {
        this.setState({ isLoading: false });
        this.getImagesFromFirebase();
    }

    handleUploadStart = () => this.setState({isUploading: true, progress: 0});
    handleProgress = (progress) => this.setState({progress});
    handleUploadError = (error) => {
        this.setState({isUploading: false});
        console.error(error);
    }
    handleUploadSuccess = (filename) => {
        this.setState({progress: 100, isUploading: false});
        this.unsubscribe = firebase.app.storage().ref('images').child(filename).getDownloadURL().then(
            url => {
                var db = firebase.app.firestore();

                db.collection("images").doc((new Date().getTime()+"")).set({
                    image: url
                });
                this.getImagesFromFirebase();
            }
        );
    };
    onCopy = () => {
        this.setState({copied: true});
        setTimeout(() => { 
            this.setState(() => ({copied: false}))
        }, 3000);
    };
    getImagesFromFirebase() {
        var db = firebase.app.firestore().collection('images');
        this.setState({isLoading: true});
        const images = [];
        db.onSnapshot((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                if (doc.data()) {
                    images.push({
                        imagesrc: doc.data().image,
                        id: doc.id,
                    });
                }
            })
            this.setState({images});
            this.setState({isLoading: false});
        }, error => console.log(error))
    }
    deleteImage = (id, url) => {
        var db = firebase.app.firestore().collection('images');
        var imgName = url.substring(url.lastIndexOf('/')+1);

        var imgDB = firebase.app.storage().ref().child('images/'+imgName);
        confirmAlert({
            title: 'Bevestig om te verwijderen',
            message: 'Weet je zeker dat je dit wilt doen?.',
            buttons: [
              {
                label: 'Ja',
                onClick: () => {
                    db.doc(id).delete();
                    imgDB.delete().then(function() {
                        console.log("Succesfully deleted");
                    }).catch(function(error) {
                        console.log("Error when deleting: " + error);
                    });
                    this.getImagesFromFirebase();
                }
              },
              {
                label: 'No',
                onClick: () => {}
              }
            ]
        })
    };
    getFileName(imgUrl) {
        var url = imgUrl;
        url = url.substring(0, (url.indexOf("#") === -1) ? url.length : url.indexOf("#"));
        url = url.substring(0, (url.indexOf("?") === -1) ? url.length : url.indexOf("?"));
        url = url.substring(url.lastIndexOf("/") + 1, url.length);
        return url;
    }
    imageBlocks() {
        return(
            <div className="media-images">
                {this.state.images.map(v => {
                    return (
                        <div className="image-wrapper">
                            <img src={v.imagesrc} alt="" />
                            <div className="buttonsWrapper">
                                <CopyToClipboard onCopy={this.onCopy} text={v.imagesrc}>
                                    <button className="left btn btn-simple btn-danger btn-icon delete" title="Klik om de afbeelding link te kopiëren"><i className="material-icons">file_copy</i></button>
                                </CopyToClipboard>
                                <button className="right btn btn-simple btn-danger btn-icon delete" title="Klik om de afbeelding te verwijderen"  onClick={() => this.deleteImage(v.id, this.getFileName(decodeURIComponent(v.imagesrc)))}><i className="material-icons">delete</i></button>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    };
    componentWillUnmount() {
        this.unsubscribe();
    };
    /**
     * generateNotifications
     * @param {Object} item - notification to be created
     */
    generateNotifications(item){
        return (
            <div className="col-md-12">
                <Notification type={item.type} >{item.content}</Notification>
            </div>
        )
    }

    render() {
        return (
            <div className="content">
			    <NavBar></NavBar>
                <div className="container-fluid">

                    {/* NOTIFICATIONS */}
                    {this.state.notifications?this.state.notifications.map((notification)=>{
                        return this.generateNotifications(notification)
                    }):""}
                    <div className="row">
                        <div className="col-md-7">
                            <div className="card">
                                <div className="card-header card-header-icon" data-background-color="green">
                                    <i className="material-icons">photo_library</i>
                                </div>
                                <div className="card-content">
                                    <h4 className="card-title">Media {this.state.copied ? <span style={{color: 'red',fontSize:12}}>Link gekopieerd</span> : null}</h4>
                                    {this.state.isLoading ? 
                                        <div style={{textAlign: 'center'}}>
                                            <Loader color="#8637AD" size="12px" margin="4px"/>
                                        </div>
                                    :
                                        this.imageBlocks()
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className="card">
                                <div className="card-header card-header-icon" data-background-color="green">
                                    <i className="material-icons">add_photo_alternate</i>
                                </div>
                                <div className="card-content">
                                    <h4 className="card-title">Nieuwe afbeelding toevoegen</h4>
                                    {this.state.isUploading &&
                                        <p>Progress: {this.state.progress}</p>
                                    }
                                    <label className="label-uploader">
                                        Selecteer afbeelding
                                        <FileUploader
                                            hidden
                                            accept="image/*"
                                            name="image"
                                            randomizeFilename
                                            storageRef={firebase.app.storage().ref('images')}
                                            onUploadStart={this.handleUploadStart}
                                            onUploadError={this.handleUploadError}
                                            onUploadSuccess={this.handleUploadSuccess}
                                            onProgress={this.handleProgress}
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Storage;


// WEBPACK FOOTER //
// ./src/containers/Storage.js